// Tamanhos fixos das barras do app mobile (px). Fonte única para quem precisa
// compensar o TopBar fixo e o BottomNavBar (MainLayout, Metrics).
export const TOP_BAR_HEIGHT = 96;
// Campo de busca do TopBar, com o espaçamento acima dele.
export const SEARCH_HEIGHT = 56;
// Conteúdo opcional abaixo da busca (ex.: abas de listas em Leads).
export const SEARCH_FOOTER_HEIGHT = 44;
export const BOTTOM_NAV_HEIGHT = 70;
export const DESKTOP_NAV_WIDTH = 64;

// Altura total do TopBar conforme o que ele mostra.
export const getTopBarHeight = ({ showSearch = false, hasSearchFooter = false } = {}) =>
  TOP_BAR_HEIGHT
  + (showSearch ? SEARCH_HEIGHT : 0)
  + (showSearch && hasSearchFooter ? SEARCH_FOOTER_HEIGHT : 0);
